import { useFormContext } from 'react-hook-form-mui';
import { FormValues } from '../types';

export function useDefaultTemplate() {
  const { watch, setValue } = useFormContext<FormValues>();
  const templates = watch('templates');

  const handleDefaultChange = (index: number, isDefault: boolean) => {
    if (isDefault) {
      // If this template is being marked as default, unmark all others
      templates.forEach((_, i) => {
        if (i !== index) {
          setValue(`templates.${i}.default`, false);
        }
      });
    }
  };

  return {
    handleDefaultChange,
  };
}
